// extracted by mini-css-extract-plugin
export var core = "app-module--core--tssmz";
export var hero = "app-module--hero--OI-dj";
export var download = "app-module--download--GITZC";
export var appInfo = "app-module--app-info--0C05s";
export var ios = "app-module--ios--4eVyE";
export var android = "app-module--android--lxa1e";